import { Fragment, useEffect, useState } from 'react'
import PageHeader from 'components/PageHeader'
import { Link, useRouteMatch } from 'react-router-dom'
import { batch, useDispatch, useSelector } from 'react-redux'
import {
  deleteReport,
  fetchReportsCustom,
  reset,
  setPage,
  setSize,
} from 'features/report/reportListSlice'
import Table from 'components/table/Table'
import Button from 'components/form/Button'
import DomainText, {
  AD_ACCOUNT,
  AD_GROUP,
  CAMPAIGN,
  CREATIVE,
  KEYWORD,
} from 'features/report/common/DomainText'
import { useConfirm } from 'features/dialog/Confirm'
import Pagination from 'components/pagination/Pagination'
import SelectBox from 'components/form/SelectBox'
import PropTypes from 'prop-types'
import PageSize from 'components/pagination/PageSize'

const ReportList = () => {
  const { url } = useRouteMatch()
  const dispatch = useDispatch()

  const [DeleteConfirm, showDeleteConfirm] = useConfirm()
  const [deleteReportId, setDeleteReportId] = useState(null)
  const [domain, setDomain] = useState('ALL')
  const { reports, page, total, size, numberOfElements, loading } = useSelector(
    state => state.report.reportList
  )

  useEffect(() => {
    dispatch(fetchReportsCustom(domain))
  }, [dispatch, page, size, domain])

  useEffect(() => () => dispatch(reset()), [dispatch])

  const onSelectDomain = v => {
    if (v) {
      setDomain(v)
      dispatch(setPage(0))
    }
  }

  const onDeleteReport = async ({ isConfirmed }) => {
    if (isConfirmed) {
      await dispatch(deleteReport({ id: deleteReportId }))
      await dispatch(fetchReportsCustom(domain))
      const isEmptyPage = () => numberOfElements === 1 && page > 0
      if (isEmptyPage()) handlePageChange(page - 1)
    }
  }

  const handlePageChange = newPage => {
    batch(() => {
      dispatch(setPage(newPage))
    })
  }

  const handleSizeChange = newSize => {
    batch(() => {
      dispatch(setSize(newSize))
      dispatch(setPage(0))
    })
  }

  return (
    <>
      <DeleteConfirm title="보고서 삭제" onClose={onDeleteReport}>
        선택한 보고서를 삭제하시겠습니까?
      </DeleteConfirm>
      <div className="report_wrap">
        <div className="dsp_tit">
          <PageHeader pageTitle="맞춤보고서 전체" />
        </div>
        <div className="ad_managebox">
          <div className="managebox_tit">
            <div className="f_left">
              <Link to={`${url}/add`} className="btn_gm gm_bl">
                <span className="inner_g">
                  <span className="img_comm ico_add" />
                  맞춤보고서 만들기
                </span>
              </Link>
            </div>
            <div className="f_right">
              <div className="single_wrap">
                <span className="ico_arr" />
                <div className="screen_out">선택옵션</div>
                <SelectBox
                  placeholder="전체"
                  value={domain}
                  onValueChange={onSelectDomain}>
                  <SelectBox.Item value="ALL" defaultSelected={true}>
                    전체
                  </SelectBox.Item>
                  <SelectBox.Item value="AD_ACCOUNT">
                    <DomainText value={AD_ACCOUNT} />
                  </SelectBox.Item>
                  <SelectBox.Item value="CAMPAIGN">
                    <DomainText value={CAMPAIGN} />{' '}
                  </SelectBox.Item>
                  <SelectBox.Item value="AD_GROUP">
                    <DomainText value={AD_GROUP} />
                  </SelectBox.Item>
                  <SelectBox.Item value="KEYWORD">
                    <DomainText value={KEYWORD} />
                  </SelectBox.Item>
                  <SelectBox.Item value="CREATIVE">
                    <DomainText value={CREATIVE} />
                  </SelectBox.Item>
                </SelectBox>
              </div>
            </div>
          </div>
          <div className="tblg2_wrap">
            <Table
              loading={loading}
              className="tbl_g2"
              caption="맞춤보고서 전체 표"
              emptyMessage={<EmptyTable url={url} />}>
              <Table.Head>
                <Table.Column title="수준" width={200} />
                <Table.Column title="맞춤보고서명" />
                <Table.Column title="삭제" width={64} />
              </Table.Head>
              <Table.Body>
                {reports.content.map(({ id, entity, name }) => (
                  <Table.Row key={id} rowId={id}>
                    <td>
                      <div className="inner_tbl">
                        <DomainText value={entity} />
                      </div>
                    </td>
                    <td>
                      <div className="inner_tbl">
                        <Link
                          to={`${url}/${entity}/${id}`}
                          className="link_txt limit_line">
                          {' '}
                          {name}
                        </Link>
                      </div>
                    </td>
                    <td className="align_c">
                      <Button
                        size="small"
                        onClick={() => {
                          setDeleteReportId(id)
                          showDeleteConfirm()
                        }}>
                        삭제
                      </Button>
                    </td>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
          {total > 0 && (
            <div className="paging_wrap">
              <div className="inner_paging">
                <Pagination
                  current={page}
                  total={total}
                  size={size}
                  onChange={handlePageChange}
                />
                <PageSize onSizeChange={handleSizeChange} size={size} />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

const EmptyTable = function ({ url }) {
  return (
    <Fragment>
      맞춤보고서가 없습니다.
      <br />
      <Link to={`${url}/add`} className="link_txt">
        맞춤보고서 만들기
      </Link>
      를 클릭하여 보고서를 생성해 주세요.
    </Fragment>
  )
}

EmptyTable.propTypes = {
  url: PropTypes.string,
}

export default ReportList
